import api from './api';

export const locationService = {
  // States
  getAllStates: async (params = {}) => {
    const { skip = 0, limit = 100 } = params;
    return api.get(`/states?skip=${skip}&limit=${limit}`);
  },
  
  getStateById: async (stateId) => {
    return api.get(`/states/${stateId}`);
  },
  
  // Cities
  getAllCities: async (params = {}) => {
    const { skip = 0, limit = 100, search } = params;
    let url = `/cities?skip=${skip}&limit=${limit}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    return api.get(url);
  },
  
  getCitiesByState: async (stateId, params = {}) => {
    const { skip = 0, limit = 100 } = params;
    return api.get(`/states/${stateId}/cities?skip=${skip}&limit=${limit}`);
  },
  
  getCityById: async (cityId) => {
    return api.get(`/cities/${cityId}`);
  },
  
  // Pincodes
  getAllPincodes: async (params = {}) => {
    const { skip = 0, limit = 100, search } = params;
    let url = `/pincodes?skip=${skip}&limit=${limit}`;
    if (search) url += `&search=${encodeURIComponent(search)}`;
    return api.get(url);
  },
  
  getPincodesByCity: async (cityId, params = {}) => {
    const { skip = 0, limit = 100 } = params;
    return api.get(`/cities/${cityId}/pincodes?skip=${skip}&limit=${limit}`);
  },
  
  getPincodeById: async (pincodeId) => {
    return api.get(`/pincodes/${pincodeId}`);
  },
  
  getPincodeByCode: async (code) => {
    return api.get(`/pincodes/code/${code}`);
  },
  
  // Admin operations (these require admin privileges)
  createState: async (stateData) => {
    return api.post('/admin/states', stateData);
  },
  
  updateState: async (stateId, stateData) => {
    return api.put(`/admin/states/${stateId}`, stateData);
  },
  
  deleteState: async (stateId) => {
    return api.delete(`/admin/states/${stateId}`);
  },
  
  createCity: async (cityData) => {
    return api.post('/admin/cities', cityData);
  },
  
  updateCity: async (cityId, cityData) => {
    return api.put(`/admin/cities/${cityId}`, cityData);
  },
  
  deleteCity: async (cityId) => {
    return api.delete(`/admin/cities/${cityId}`);
  },
  
  createPincode: async (pincodeData) => {
    return api.post('/admin/pincodes', pincodeData);
  },
  
  updatePincode: async (pincodeId, pincodeData) => {
    return api.put(`/admin/pincodes/${pincodeId}`, pincodeData);
  },
  
  deletePincode: async (pincodeId) => {
    return api.delete(`/admin/pincodes/${pincodeId}`);
  }
};

// Export simplified API for component use
export const locationApi = {
  getStates: () => locationService.getAllStates(),
  getCities: (stateId) => locationService.getCitiesByState(stateId),
  getPincodes: (cityId) => locationService.getPincodesByCity(cityId),
  getPincodeByCode: (code) => locationService.getPincodeByCode(code)
};

export default locationService;